// extracted by mini-css-extract-plugin
export var parcelRow = "_tg-0";